export enum PropertyType {
  Flat = 'apartment',
  House = 'house',
}
